module.exports = __webpack_public_path__ + "img/ic_product_box_add.032fdf0e.svg";